<ion-tabs>
  <ion-tab-bar slot="bottom">
    <ion-tab-button tab="home" (click)="switchTabs('dashboard', 1)">
      <ion-icon name="home-outline"></ion-icon>
      <ion-label>Beranda</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="barcode" (click)="switchTabs('data', 2)">
      <ion-icon name="document-outline"></ion-icon>
      <ion-label>Remun</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="akun" (click)="switchTabs('account', 3)">
      <ion-icon name="person-outline"></ion-icon>
      <ion-label>Akun</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>